// extracted by mini-css-extract-plugin
module.exports = {"banner":"_382pA3s7p1Z8YjEElzROoN","text":"_1nUgpuaRE41dTdWA-bWwqM","cta":"_2rR5bSnicV7jB1xSKf3kCs"};